import React from "react";

const ActiveMembers = React.lazy(() => import("./ActiveMembers"));
const ActiveMemberWithNoDoorOpening = React.lazy(() =>
  import("./ActiveMemberWithNoDoorOpening")
);

export const ReportsRoutes = [
  {
    path: "/admin/reports/activeMembers",
    name: "ActiveMembers",
    element: <ActiveMembers />,
  },
  {
    path: "/admin/reports/lastOpeningDoor",
    name: "lastOpeningDoor",
    element: <ActiveMemberWithNoDoorOpening />,
  },
];
